__turbopack_context__.v({
  "errorPage": "error-page-module-scss-module__vhp-Xq__errorPage",
  "errorPage_actions": "error-page-module-scss-module__vhp-Xq__errorPage_actions",
  "errorPage_button": "error-page-module-scss-module__vhp-Xq__errorPage_button",
  "errorPage_content": "error-page-module-scss-module__vhp-Xq__errorPage_content",
  "errorPage_description": "error-page-module-scss-module__vhp-Xq__errorPage_description",
  "errorPage_footer": "error-page-module-scss-module__vhp-Xq__errorPage_footer",
  "errorPage_image": "error-page-module-scss-module__vhp-Xq__errorPage_image",
  "errorPage_info": "error-page-module-scss-module__vhp-Xq__errorPage_info",
  "errorPage_title": "error-page-module-scss-module__vhp-Xq__errorPage_title",
});
